import { MessageCircle } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "@/lib/site";

export const WhatsAppFloat = () => (
  <a
    data-testid="floating-whatsapp-pill"
    href={waLink(DEFAULT_WA_MESSAGE)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with JK Furniture on WhatsApp"
    className="whatsapp-pulse fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] transition-transform duration-200 hover:scale-105"
  >
    <MessageCircle size={24} />
  </a>
);
